export class FilterParams {
  jobTitleSelectedList: any[];
  jobTitleStatus: string;

  pastJobTitleSelectedList: any[];

  locationSelectedList: any[];

  skillsSelectedList: any[];

  companySelectedList: any[];
  companyStatus: string;

  companySizeSelectedList: any[];
  companysize: any;
  isCompanySizeSelected: boolean;

  industrySelectedList: any[];
  industryStatus: string;

  functionSelectedList: any[];
  // functionsInput?: any; Logic for this should be handled in filter component

  seniorityLevelSelectedList: any[];
  seniority: any;

  // yearsofexperienceFrom?: any; Logic for this should be handled in filter component
  yearsofexperienceTo?: any;
  yearsofexperienceFrom?: any;
  filterAppliedOnYearsOfExperience: boolean;
  yearsofexperience: any;

  currentfromyearsofexperience: any;
  currenttoyearsofexperience: any;
  filterAppliedOnCurrentYearsOfExperience: boolean;

  gender: any;
  isGenderSelected: boolean;
  isFemaleMatrixSelected: boolean;
  isMaleMatrixSelected: boolean;

  educationSelectedList: any[];

  schoolSelectedList: any[];
  schoolLocationSelectedList: any[] 

  fieldOfStudySelectedList: any[];

  filterLikelyToMoveIn: any;
  candidateslikelytomove: any;
  isLikelyToMoveInFilterSelected: boolean;

  isChangedJobsSelected: boolean;
  changedJobStatus: any;
  changedJobStartDuration: number;
  changedJobEndDuration: number;

  talentdiscoveryhistoryid: string;
  
  continentstobeincluded: any[];
  searchHistoryRegion: string | null;

  keywordSelectedList: any[];
  booleanquery?: string;
  fullnameSelectedList: any[];
  winningtalent: any;

  distancefromselectedlocationsmeasurementunit: string;
  distancefromselectedlocations: number
}
